import React from "react";
import { SpaceEditorContainer } from "./styled";
import DynamicSpaces from "../data/DynamicSpaces";
import ManualSpaces from "../data/ManualSpaces";
import { useSpacesStore } from "../../../stores/use-space-store";
import EditingTabs from "../tabs/EditingTabs";

function SpacesEditor() {
  const { data, selectedTab } = useSpacesStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
  }));

  const { enrichment } = data.config.tabs[selectedTab] || {};

  return (
    <SpaceEditorContainer>
      <EditingTabs />
      {enrichment === "dynamic" && <DynamicSpaces />}
      {enrichment === "manually" && <ManualSpaces isEdit />}
    </SpaceEditorContainer>
  );
}

export default SpacesEditor;
